import Column from '@components/Column';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';
import ScrollBar from '@components/ScrollBar';
import { useRef } from 'react';

import useStampHistories from './hooks/useStampHistories';
import StampLogRow from './StampLogRow';
import styles from './styles.module.scss';

interface Props {
    shopId: string;
    expand: boolean;
}

function StampLog({ expand, shopId }:Props) {
    const contentsRef = useRef<HTMLDivElement>(null);
    const { histories, fetchNextPage } = useStampHistories(shopId);
    return (
        <div className={`${styles.wrapper} ${(!expand) ? styles.hide : ''}`} >
            <Column className={styles.container}
                fullWidth
                spacing={20}>
                <div className={styles.divider}/>
                <div className={styles.contentsContainer}>
                    <Column className={styles.contents}
                        ref={contentsRef}
                        fullWidth spacing={16}>
                        {histories?.map((log, i) => (
                            <StampLogRow stampHistory={log} key={i.toString()}/>
                        ))}
                        <InfinityScrollTrigger trigger={fetchNextPage}/>
                    </Column>
                    <ScrollBar containerRef={contentsRef}
                        containerHeight={360}/>
                </div>
            </Column>
        </div>
    );
}

export default StampLog;
